module.exports = __webpack_public_path__ + "b0932b40a7299997a61407a6481f8baa.svg";